import React, { Component } from 'react';
// import Form from '@rjsf/material-ui';
import Form from "react-jsonschema-form";
import validator from '@rjsf/validator-ajv8';


class JsonFormSchema extends Component {
    state = {  }
    render() {
        return (
            <Form
                {...this.props}
                // formData={!isEmpty(this.state.info) && this.state.info[0]}
                // schema={this.state.schema}
                // uiSchema={this.state.uiSchema}
                // onChange={args => this.handleOnChange(args)}
                // onSubmit={args => this.handleSubmit(args)}
                validator={validator}
            />
        );
    }
}

export default JsonFormSchema;